import React from "react";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import HomePage from "./pages/HomePage";
import DataPage from "./pages/DataPage";
import CalendarPage from "./pages/CalendarPage";
import ModelPage from "./pages/ModelPage";
import NavBar from "./components/NavBar";
import { LanguageProvider } from "./context/LanguageContext";
import "./App.css"; // or NavBar.css

import iconImage from "./icon.png";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <nav className="navbar">
          <NavBar />
        </nav>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/data" element={<DataPage />} />
          <Route path="/model" element={<ModelPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
